import React from 'react';
import { connect, DispatchProp } from 'react-redux';

import {
    BaseFeat,
    BuilderChoiceOptionContract,
    characterActions,
    ChoiceData,
    ChoiceUtils,
    FeatUtils,
    HtmlSelectOption,
    rulesEngineSelectors,
} from '@dndbeyond/character-rules-engine/es';

import { SharedAppState } from '../../../stores/typings';
import DetailChoice from '../DetailChoice';

interface Props extends DispatchProp {
    featId: number;
    choiceInfo: ChoiceData;
    feats: Array<BaseFeat>;
}
class DetailChoiceFeat extends React.PureComponent<Props> {
    handleChoiceChange = (id: string | null, type: number, subType: number | null, value: any): void => {
        const { dispatch, featId } = this.props;

        if (id !== null) {
            dispatch(characterActions.featChoiceSetRequest(featId, type, id, value));
        }
    };

    render() {
        const { featId, feats } = this.props;
        const { choiceInfo } = this.props;

        const feat = feats.find((feat) => FeatUtils.getId(feat) === featId);

        if (!feat) {
            return null;
        }

        const choices = FeatUtils.getChoices(feat);
        if (choices.length === 0) {
            return null;
        }

        return (
            <div className="ct-detail-choice-feat">
                {choices.map((choice) => {
                    const options = ChoiceUtils.getOptions(choice);
                    const id = ChoiceUtils.getId(choice);

                    //TODO REI - notes to refactor in DetailChoice
                    let featChoiceOptions: Array<HtmlSelectOption & BuilderChoiceOptionContract> = options.map(
                        (option) => {
                            return {
                                ...option,
                                value: option.id,
                            };
                        },
                    );

                    return (
                        <DetailChoice
                            {...choice}
                            choice={choice}
                            key={id !== null ? id : ''}
                            options={featChoiceOptions}
                            onChange={this.handleChoiceChange}
                            choiceInfo={choiceInfo}
                            showBackgroundProficiencyOptions={true}
                        />
                    );
                })}
            </div>
        );
    }
}

function mapStateToProps(state: SharedAppState) {
    return {
        choiceInfo: rulesEngineSelectors.getChoiceInfo(state),
        feats: rulesEngineSelectors.getBaseFeats(state),
    };
}

export default connect(mapStateToProps)(DetailChoiceFeat);
